import { Component, inject } from '@angular/core';
import { UploadService } from '../upload.service';

@Component({
  selector: 'sb-comp-uploading-element',
  templateUrl: './uploading-element.component.html',
  styleUrls: ['./uploading-element.component.scss'],
  standalone: false,
})
export class UploadingElementComponent {
  protected readonly uploadService = inject(UploadService);

  options: { loop: boolean; autoplay: boolean } = {
    autoplay: true,
    loop: true,
  };
}
